<template>
  <div>
    <table border="1" style="border-bottom:0">
      <!-- 第一行(1表) -->
      <tr style="height:100px">
        <td width="30%" class="titleSpan companyTitle KaiTi">河南邦泰合力管理咨询有限公司</td>
        <td width="40%" class="titleSpan tableTitle">企 业 情 况 调 查 表</td>
        <td style="border:0" class="titleSpan">BTHL-GK-001</td>
      </tr>
    </table>
    <table border="1">
      <!-- 第二行(2表) -->
      <tr style="height:50px">
        <td width="15%" class="titleSpan">企业名称</td>
        <td width="45%" class="contentSpan">{{printData.company_name}}</td>
        <td width="15%" class="titleSpan">联系电话</td>
        <td class="contentSpan">{{printData.contact_number}}</td>
      </tr>
      <tr style="height:50px">
        <td width="15%" class="titleSpan">地址</td>
        <td colspan="3" class="contentSpan">{{printData.company_name}}</td>
      </tr>
    </table>
    <table border="1" style="border-top:0">
      <!-- 第三行(3表) -->
      <tr style="height:50px">
        <td width="15%" class="titleSpan">主要负责人</td>
        <td width="30%" class="contentSpan">{{printData.company_name}}</td>
        <td width="15%" class="titleSpan">调查日期</td>
        <td class="contentSpan">{{printData.contact_number}}</td>
      </tr>
      <!-- 第四行(3表) -->
      <tr style="height:50px">
        <td width="15%" class="titleSpan">经济类型</td>
        <td width="30%" class="contentSpan">{{printData.company_name}}</td>
        <td width="15%" class="titleSpan">从业人数</td>
        <td class="contentSpan">{{printData.contact_number}}</td>
      </tr>
      <!-- 第五行(3表) -->
      <tr style="height:80px">
        <td width="15%" class="titleSpan">
          <div>投资规模</div>
          <div>( 万元 )</div>
        </td>
        <td width="30%" class="contentSpan">{{printData.company_name}}</td>
        <td width="15%" class="titleSpan">生产能力</td>
        <td class="contentSpan">{{printData.contact_number}}</td>
      </tr>
      <!-- 第六行(3表) -->
      <tr style="height:50px">
        <td width="15%" class="titleSpan">企业类型</td>
        <td width="30%" class="contentSpan">{{printData.company_name}}</td>
        <td width="15%" class="titleSpan">评价类型</td>
        <td class="contentSpan">{{printData.contact_number}}</td>
      </tr>
      <!-- 第七行(3表) -->
      <tr style="height:50px">
        <td width="15%" class="titleSpan">企业联系人</td>
        <td width="30%" class="contentSpan">{{printData.company_name}}</td>
        <td width="15%" class="titleSpan">调查人</td>
        <td class="contentSpan">{{printData.contact_number}}</td>
      </tr>
    </table>
    <table border="1" style="border-top:0">
      <!-- 第八行-1(4表) -->
      <tr style="height:50px">
        <td width="15%" rowspan="2" class="titleSpan">
          <div>安全生产</div>
          <div>( 经营 )</div>
        </td>
        <td width="15%" class="titleSpan">发证机关</td>
        <td colspan="2" class="contentSpan">{{printData.contact_number}}</td>
      </tr>
      <!-- 第八行-2(4表) -->
      <tr style="height:50px">
        <td width="15%" class="titleSpan">证号</td>
        <td colspan="2" class="contentSpan">{{printData.contact_number}}</td>
      </tr>
      <!-- 第九行-1(4表) -->
      <tr style="height:50px">
        <td width="15%" rowspan="2" class="titleSpan">
          <div>营业执照</div>
          <div>( 企业名称预先 )</div>
        </td>
        <td width="15%" class="titleSpan">发证机关</td>
        <td colspan="2" class="contentSpan">{{printData.contact_number}}</td>
      </tr>
      <!-- 第九行-2(4表) -->
      <tr style="height:50px">
        <td width="15%" class="titleSpan">证号</td>
        <td colspan="2" class="contentSpan">{{printData.contact_number}}</td>
      </tr>
      <!-- 第十行-1(4表) -->
      <tr style="height:50px">
        <td width="15%" rowspan="2" class="titleSpan">采矿证</td>
        <td width="15%" class="titleSpan">发证机关</td>
        <td colspan="2" class="contentSpan">{{printData.contact_number}}</td>
      </tr>
      <!-- 第十行-2(4表) -->
      <tr style="height:50px">
        <td width="15%" class="titleSpan">证号</td>
        <!-- <td colspan="2">{{printData.contact_number}}</td> -->
        <td
          colspan="2"
          class="contentSpan"
        >{{'测试长度测试长度测试长度123测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度'}}</td>
      </tr>
      <!-- 第十一行(4表) -->
      <tr style="height:350px">
        <td colspan="4" style="text-align:left;">
          <div style="min-height:350px;box-sizing:border-box;padding:10px">基本情况:</div>
          <!-- <div style="height:480px">基本情况:</div> -->
          <!-- <div style="height:20px">(不够可附页)</div> -->
        </td>
      </tr>
      <!-- 第十二行(4表) -->
      <tr style="height:100px">
        <td colspan="4" style="text-align:left;">
          <div
            style="min-height:100px;box-sizing:border-box;padding:10px"
          >{{`企业特殊要求 : ${'测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度测试长度'}`}}</div>
        </td>
      </tr>
      <!-- 第十三行(4表) -->
      <tr style="height:100px">
        <td colspan="4" style="text-align:left;">
          <div style="min-height:100px;box-sizing:border-box;padding:10px;" class="wirteTableRow">
            <div class="pic">
              <div>调查人签字:</div>
              <img src="../../assets/image/icon_MP4@2x.png" alt />
            </div>
            <div>年月日</div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
export default {
  data() {
    return {
      // 评价类别
      pjTypeList: [
        {
          id: '1',
          label: '预评价',
        },
        {
          id: '2',
          label: '验收评价',
        },
        {
          id: '3',
          label: '现状评价',
        },
        {
          id: '4',
          label: '专项评价',
        },
        {
          id: '5',
          label: '其它',
        },
      ],
    }
  },
  computed: {
    ...mapState('process/projectTable', ['printData']),
  },
  methods: {},
  mounted() {},
  async created() {},
}
</script>
<style lang="less" scoped>
@import url(./printDialog.scss);
</style>